import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Menu from "./Menu";
import Coach from "./Coach";
import Contact from "./Contact";

function App() {
  return (
    <div className="App">
      <Menu />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
